import React from 'react';
import { Home, ShoppingCart, History, User } from '../icons';

export const NavBar = ({ currentView, setView, cartItemCount }) => {
    const navItems = [
        { name: 'Dashboard', icon: Home, view: 'dashboard' },
        { name: 'Cart', icon: ShoppingCart, view: 'cart' },
        { name: 'History', icon: History, view: 'orderHistory' },
        { name: 'Profile', icon: User, view: 'profile' },
    ];

    return (
        <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 flex justify-around p-2 z-20 shadow-2xl">
            {navItems.map(({ name, icon: Icon, view }) => (
                <button
                    key={view}
                    onClick={() => setView(view)}
                    className={`flex flex-col items-center p-2 rounded-xl transition duration-300 ${
                        currentView === view
                            ? 'text-[#01a499] font-bold'
                            : 'text-gray-500 hover:text-[#01a499]'
                    }`}
                >
                    <div className="relative">
                        <Icon className="w-6 h-6" />
                        {view === 'cart' && cartItemCount > 0 && (
                            <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center">
                                {cartItemCount}
                            </span>
                        )}
                    </div>
                    <span className="text-xs mt-1">{name}</span>
                </button>
            ))}
        </div>
    );
};
